export const loadingPageTestIDs = {
  loadingPage: 'loading_page',
  loadingText: 'loading_page_loading_text',
};
